<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.form.$invalid },]")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(autofocus :placeholder='$t("branches.concept_code_placeholder")' :danger="$v.form.concept_code.$invalid && $v.form.concept_code.$model" :danger-text="(form.concept_code) ? $t('validation.numeric', { attribute: $t('branches.concept_code') }) : $t('validation.required', { attribute: $t('branches.concept_code') })" v-model="form.concept_code" :label='$t("branches.concept_code")')
          vm-input(autofocus :placeholder='$t("branches.name_placeholder")' :danger="$v.form.name.$invalid && $v.form.name.$model" :danger-text="$t('validation.required', { attribute: $t('branches.name') })" v-model="form.name" :label='$t("branches.name")')
          vm-input(autofocus :placeholder='$t("branches.name_contpaq_placeholder")' :danger="$v.form.warehouse_name.$invalid && $v.form.warehouse_name.$model" :danger-text="$t('validation.required', { attribute: $t('branches.warehouse_name') })" v-model="form.warehouse_name" :label='$t("branches.warehouse_name")')
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required, numeric } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Branches')

export default {
  name: 'ModalBranches',
  mixins: [ModalMixin1],
  validations () {
    return {
      form: {
        concept_code: {
          numeric,
          required
        },
        name: {
          required
        },
        warehouse_name: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isModalVisible', 'catalog'])
  },
  async created () {
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'addRecord',
      'editRecord',
      'deleteRecord',
      'setModalVisible',
      'loadCatalog'
    ])
  }
}
</script>
